import { capitalizeFirstLetter } from './string';

// Employee statuses that can be managed/assigned a pay cycle: everyone who isn't terminated or
// inactive. This is the include-list counterpart of `isAssignableStatus` on the pay-cycle
// employees screen, and drives the Status filter's default so the table opens on the employees an
// admin can actually act on (active + still-onboarding/blocking), with inactive/terminated one
// click away. Keep this in sync with `isAssignableStatus`.
export const MANAGEABLE_PAY_CYCLE_EMPLOYEE_STATUSES = ['Active', 'Onboarding', 'Blocking'];

/**
 * Formats a pay cycle label for dropdowns
 * @param paySchedule - The pay cycle object containing name and payFrequency
 * @returns Formatted label string
 *
 * Logic:
 * - If no name: show frequency (e.g., "Weekly")
 * - If name equals frequency (case insensitive): show just name (e.g., "Weekly")
 * - If name differs from frequency: show "Name (frequency)" (e.g., "Main Payroll (Weekly)")
 * - Fallback: "-"
 */
export const formatPayScheduleLabel = (paySchedule: { name?: string; payFrequency?: string }): string => {
  const frequency = capitalizeFirstLetter(paySchedule?.payFrequency?.toLowerCase() || '');
  const name = paySchedule?.name;

  if (!name) {
    return frequency || '-';
  } else if (name.toLowerCase() === frequency.toLowerCase()) {
    return name; // Show just the name if it's the same as frequency
  } else {
    return `${name} (${frequency})`;
  }
};

/**
 * Check stores autopilot as a string on the pay cycle's metadata, so every read goes through here
 * rather than casting the metadata away at each call site.
 */
export const isAutopilotOn = (paySchedule?: { metadata?: unknown } | null): boolean =>
  (paySchedule?.metadata as { autopilotEnabled?: string } | undefined)?.autopilotEnabled === 'true';
